import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { InputFieldStyle } from './InputFieldStyle';

const InputField = ({
  theme,
  shape,
  type,
  inputName,
  value,
  placeholder,
  icon,
  instructions,
  error,
  disabled,
  noMarginBottom,
  onChange,
  onKeyDown,
}) => {
  const classNames = useMemo(() => {
    const current = [];

    if (theme?.length) {
      current.push(`${theme}-theme`);
    }

    if (shape?.length) {
      current.push(`${shape}-shape`);
    }

    if (error?.length) {
      current.push('with-error');
    }

    if (noMarginBottom) {
      current.push('no-margin-bottom');
    }

    if (!icon) {
      current.push('no-icon');
    }

    if (instructions?.length) {
      current.push('with-instructions');
    }

    return current;
  }, [error?.length, icon, instructions?.length, noMarginBottom, shape, theme]);

  return (
    <InputFieldStyle className={classNames}>
      <div className="input-wrapper">
        {icon ? <span className="input-icon">{icon}</span> : null}
        <input
          type={type}
          className="input-element"
          placeholder={placeholder}
          name={inputName}
          value={value}
          disabled={disabled || !onChange}
          onChange={
            onChange ? (event) => onChange(event.currentTarget.value) : null
          }
          onKeyDown={
            onKeyDown ? (event) => onKeyDown(event.key) : null
          }
        />
      </div>
      {error.length ? <p className="input-error">{error}</p> : null}
      {instructions.length && !error.length ? (
        <p className="input-instructions">{instructions}</p>
      ) : null}
    </InputFieldStyle>
  );
};

InputField.propTypes = {
  theme: PropTypes.string,
  type: PropTypes.string,
  shape: PropTypes.string,
  inputName: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  placeholder: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.node]),
  instructions: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  noMarginBottom: PropTypes.bool,
  onChange: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.func]),
  onKeyDown: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.func]),
};

InputField.defaultProps = {
  theme: 'default',
  shape: 'rounded',
  type: 'text',
  placeholder: '',
  icon: null,
  instructions: '',
  error: '',
  disabled: false,
  noMarginBottom: false,
  onChange: null,
  onKeyDown: null,
};

export default InputField;
